import React, { useEffect, useState } from 'react'
import CustomerDetails from '../components/GroupListDetails/CustomerDetails'
import Footer from '../components/Footer'
import Header from '../components/Header'
import { fetchLabels } from '../utils/Label'
import { fetchData } from '../utils/Utils'
import { voiceStore } from '../stores/voiceStore'
import { observer } from 'mobx-react-lite'

const CustomerInfo = () => {
  const [labels, setLabels] = useState('')
  const [customerInfo, setCustomerInfo] = useState(null);

  useEffect(() => {
    //Fetch Label:
    const fetchLabelsData = async () => {
      const updatedLabels = await fetchLabels();
      setLabels(updatedLabels)
    };

    fetchLabelsData();
  }, [sessionStorage.getItem("CommunicationLanguage"), voiceStore.language]);

  useEffect(() => {
    fetchData()
      .then(data => {
        setCustomerInfo(data.data);
        voiceStore.setVoiceCommand(data?.data?.GroupDetails?.Customers[0]?.NextInstalmentDetails?.VoiceCommand4)
      })
      .catch(error => {
        console.error('Error:', error);
      });
  }, []);

  return (
    <>
      <div className="flex flex-col min-h-screen">
        <Header breadcrumbs="Customer App" labels={labels} customerInfo={customerInfo} />
        <div className="flex-grow mx-4 mb-16 overflow-auto font-gotham-rounded">
          <CustomerDetails labels={labels} customerInfo={customerInfo} />
        </div>
        <Footer className="fixed bottom-0 w-full bg-white" labels={labels} customerInfo={customerInfo} />
      </div>
    </>
  )
}

export default observer(CustomerInfo)